export default __webpack_public_path__ + "static/5-2e2dd5679fbe1b93887d09cd16d47438.png";